"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Main = void 0;
var _Modal = require("../../../Layout/Modal");
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
var _Button = require("../../../UI/Button");
var _TaskType = require("./partials/TaskType");
var _EditTaskData = require("./partials/EditTaskData");
var _AssignTo = require("./partials/AssignTo");
var _Schedule = require("./partials/Schedule");
var _encoders = require("../../../utilities/encoders");
var _urls = require("../../../utilities/urls");
var _http = require("../../../utilities/http");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _dates = require("../../../utilities/dates");
var _hooks = require("../../../hooks");
var _TaskManager2 = _interopRequireDefault(require("../TaskManager.styles"));
var _TaskManager3 = require("../TaskManager.utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Main = props => {
  const {
    handleClose,
    audiencePickerProvider,
    onSave,
    productID,
    itemID,
    audienceID,
    environmentID,
    kotarParams,
    isEditTaskDataEnabled = true,
    isLearningActivity = false
  } = props;
  const {
    language,
    hostKey
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    getLabel,
    originalTask,
    setOriginalTask,
    task,
    setTask,
    setReSubmitTaskAfterTaskTypeChanged,
    isChanged,
    isUpdate,
    setIsSavingItem,
    setIsSavedItem,
    setIsSaveItemError,
    setSelectedGroups,
    setSelectedStudents,
    setUpdateTaskTypeAfterExamStart,
    setOnCloseData
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    sendUiUsageEvent,
    sendLearningEvent
  } = (0, _hooks.useCetEvents)();
  const {
    userId
  } = (0, _hooks.useSessionData)();
  const audiencePickerSelectedData = audiencePickerProvider?.getSelectedGroupsAndStudentsData && audiencePickerProvider.getSelectedGroupsAndStudentsData();
  const styles = (0, _TaskManager2.default)();
  const isTaskValidate = () => {
    if (environmentID && !task.assignTo) {
      task.assignTo = 'all';
    }
    return task?.assignTo === 'all' || audiencePickerSelectedData && (audiencePickerSelectedData.selectedGroups && audiencePickerSelectedData.selectedGroups.length > 0 || audiencePickerSelectedData.selectedStudents && audiencePickerSelectedData.selectedStudents.length > 0);
  };
  const handleSaveTask = async () => {
    const saveTask = async function () {
      let isUpdateTaskTypeAfterExam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let newTask = {
        ...task
      };
      newTask.name = (0, _encoders.htmlEncode)(newTask.name);
      newTask.schoolID = audiencePickerProvider.itemSchoolId;
      newTask.cultureName = language;
      newTask.hostKey = hostKey;
      if (environmentID) {
        //if TOC task
        newTask.environmentId = environmentID;
        newTask.folderId = itemID ? itemID.split('_')[0] : null;
        newTask.productId = productID;
      }
      const groups = environmentID ? 'audienceGroups' : 'groups';
      const students = environmentID ? 'audienceStudents' : 'students';
      if (task.assignTo === 'all') {
        //if TOC task for all students
        setSelectedGroups([]);
        setSelectedStudents([]);
        newTask.audienceId = audienceID;
        newTask[groups] = [];
        newTask[students] = [];
      } else if (!environmentID || newTask.assignTo === 'some') {
        //if regular task or TOC differential task
        newTask[groups] = audiencePickerSelectedData?.selectedGroups.map(group => {
          return {
            id: group.group.id,
            groupType: group.group.groupType,
            name: group.group.name.replace(/``/g, '"') // Reblaze rejects 2 backticks as an SQL injection attempt
          };
        });
        newTask[students] = audiencePickerSelectedData?.selectedStudents.map(student => {
          return {
            contextID: student.classIds && student.classIds.length > 0 ? student.classIds[0] : student.groupIds && student.groupIds.length > 0 ? student.groupIds[0] : null,
            studentID: student.student.id,
            studentName: student.student.fullName
          };
        });
        if (newTask.assignTo === 'some') {
          //if TOC differential task
          const audienceGroups = audiencePickerSelectedData?.selectedGroups.map(group => {
            return group.group.id;
          });
          const audienceStudents = audiencePickerSelectedData?.selectedStudents.map(student => {
            return {
              ContextGroupID: student.classIds && student.classIds.length > 0 ? student.classIds[0] : student.groupIds && student.groupIds.length > 0 ? student.groupIds[0] : null,
              ContextAudienceID: student.classIds && student.classIds.length > 0 || student.groupIds && student.groupIds.length > 0 ? null : audienceID,
              UserID: student.student.id
            };
          });
          let audienceData = {
            Groups: audienceGroups,
            SingleUsers: audienceStudents
          };
          if (task.audienceId && task.audienceId !== audienceID) {
            audienceData.AudienceId = task.audienceId;
          }
          const response = await fetch(`${_urls.ofakimApiUrl}/lmscp/upsertAudience`, {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json'
            },
            referrerPolicy: 'no-referrer',
            credentials: 'include',
            redirect: 'follow',
            body: JSON.stringify(audienceData)
          });
          newTask.audienceId = await response.json();
        }
      }
      if (!isLearningActivity) {
        newTask.startDateTime = (0, _dates.normalizeTimeWithOffset)(newTask.startDateTime);
        newTask.endDateTime = (0, _dates.normalizeTimeWithOffset)(newTask.endDateTime);
        newTask.publishDate = (0, _dates.normalizeTimeWithOffset)(newTask.publishDate);
        newTask.feedbackDate = (0, _dates.normalizeTimeWithOffset)(newTask.feedbackDate);
        newTask.timeZoneOffset = newTask.startDateTime.getTimezoneOffset() * -1 / 60;
      }
      if (kotarParams) {
        newTask.externalUrl = window.unescape(kotarParams.returnUrl || '');
        newTask.externalUrlTitle = kotarParams.returnTitle || '';
      }

      //fix old googleTask api logic (Disable Task Support with googleShare)
      if (!('ExternalTaskStatus' in newTask)) {
        newTask.ExternalTaskStatus = -1; //googleTask.externalTaskStatus.NotExist
      }

      //fix old api logic (Disable selection of cetSubject)
      if (!('cetSubject' in newTask)) {
        newTask.cetSubject = newTask.item?.cetSubject || 'other';
      }
      setIsSavingItem(true);
      const newTaskData = (0, _TaskManager3.getSavedTaskData)(newTask, isLearningActivity, userId);
      const saveApi = (0, _TaskManager3.getSaveApi)(isLearningActivity);
      _http.http.post(saveApi, newTaskData).then(data => {
        const taskId = data.taskID || data.taskId;
        if (data && taskId) {
          setTask({
            ...task,
            id: taskId,
            singleUsersCount: data?.singleUsersCount
          });
          setOriginalTask({
            ...task
          });
          setIsSavingItem(false);
          setIsSaveItemError(false);
          if (isUpdateTaskTypeAfterExam) {
            setUpdateTaskTypeAfterExamStart(null);
            setReSubmitTaskAfterTaskTypeChanged({
              handleConfirm: () => {
                setIsSavedItem(true);
              }
            });
          } else {
            setIsSavedItem(true);
          }
          const onCloseData = {
            taskID: taskId,
            name: newTask.name,
            isLinkedToUser: data.isLinkedToUsers,
            task: newTask
          };
          setOnCloseData(onCloseData);
          sendUiUsageEvent({
            category: 'assignActivity',
            label: 'assign'
          });
          const learningEventParams = {
            verbType: 'added',
            objectId: taskId,
            objectName: newTask.name,
            objectType: 'task',
            optionalData: {
              taskType: newTask.taskType,
              taskId: taskId,
              taskPublishedDate: newTask.publishDate,
              loId: newTask.item.id,
              contentSubject: newTask.cetSubject,
              objectAdditionalInformation: {}
            }
          };
          if (newTask[groups] && newTask[groups].length > 0) {
            learningEventParams.optionalData.objectAdditionalInformation.groups = newTask[groups].map(group => {
              return {
                id: group.id,
                groupType: group.groupType
              };
            });
          }
          if (newTask[students] && newTask[students].length > 0) {
            learningEventParams.optionalData.objectAdditionalInformation.students = newTask[students].map(student => {
              return {
                contextID: student.contextID,
                studentID: student.studentID
              };
            });
          }
          sendLearningEvent(learningEventParams);
          if (onSave) {
            onSave(onCloseData);
          }
        } else {
          setIsSavingItem(false);
          setIsSavedItem(false);
          setIsSaveItemError(true);
        }
      }).catch(error => {
        setIsSavingItem(false);
        setIsSavedItem(false);
        setIsSaveItemError(true);
      });
    };
    if (isChanged && !(task && task.isReadOnly) && isTaskValidate()) {
      if (originalTask?.taskType === 'exam' && task?.taskType !== 'exam' && task?.cannotModifyMembers) {
        setUpdateTaskTypeAfterExamStart({
          handleConfirm: () => {
            saveTask(true);
          }
        });
      } else {
        saveTask();
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__full-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: getLabel('main_title'),
      subTitle: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-TaskManager__subtitle'],
        children: [task?.name ? task?.name + ' ' : ' ', isEditTaskDataEnabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditTaskData.EditTaskData, {
          ...props
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: task && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TaskType.TaskType, {
          ...props
        }), task.taskType !== 'selfLearning' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Schedule.Schedule, {
          ...props
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AssignTo.AssignTo, {
          ...props
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          onClick: handleClose,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: task && !task.isReadOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "contained",
          color: "primary",
          onClick: handleSaveTask,
          isDisabled: !isChanged || !isTaskValidate(),
          children: isUpdate ? getLabel('update_task_btn') : getLabel('save_task_btn')
        })
      })]
    })]
  });
};
exports.Main = Main;